import React, { FC, PropsWithChildren, ReactNode } from 'react'

import { Box } from '../box'
import { HStack } from '../hstack'
import { Text } from '../text'

export interface SidebarProps {
    title: ReactNode
    subtitle?: ReactNode
    /** Optional right-aligned action on the title row (e.g. a "Show on map" link). */
    titleAction?: ReactNode
}

export const Sidebar: FC<PropsWithChildren<SidebarProps>> = props => (
    <Box className='w-[360px] shrink-0 flex-col bg-background-surface'>
        <HStack className='shrink-0 items-center justify-between px-8 pb-4 pt-8'>
            <Text size='heading' tone='default'>
                {props.title}
            </Text>
            {props.titleAction}
        </HStack>
        {props.subtitle && (
            <Text size='body' tone='default' className='shrink-0 px-8'>
                {props.subtitle}
            </Text>
        )}
        <Box className='min-h-0 flex-1'>
            <Box className='h-full overflow-y-auto px-8 py-1'>
                <Box className='shrink-0'>{props.children}</Box>
            </Box>
        </Box>
    </Box>
)
